import axios from "axios"
import logout from "../services/logout"

const dev = process.env.NODE_ENV === "development"

const RealApiClient = axios.create({
  baseURL: process.env?.VUE_APP_API_BASE_URL || "http://localhost:3000/api"
})

RealApiClient.interceptors.request.use(
  req => {
    /* skip adding token if user is logging in */
    if (!req.url.includes("login")) {
      const token = localStorage.getItem("access-token")
      if (token === null) {
        logout()
        throw new Error("No access token found.")
      } else {
        req.headers.authorization = `Bearer ${token}`
      }
    }
    return req
  },
  error => {
    if (dev) console.error(error)
    return Promise.reject(error)
  }
)

/* Intercept 401 - unauthorized responses and redirect to login page */
RealApiClient.interceptors.response.use(
  res => {
    return res
  },
  error => {
    if (error?.response?.status === 401) logout()
    return Promise.reject(error)
  }
)

/* __DEMO_MODE__ is a compile-time constant (vue.config.js DefinePlugin).
   Conditional require keeps the demo fixture out of production bundles. */
let ApiClient
if (__DEMO_MODE__) {
  ApiClient = require("./demoClient").default
} else {
  ApiClient = RealApiClient
}

export default ApiClient
